import { render, staticRenderFns } from "./cooperation-visa-detail-list.vue?vue&type=template&id=60a4048b&scoped=true&"
import script from "./cooperation-visa-detail-list.vue?vue&type=script&lang=js&"
export * from "./cooperation-visa-detail-list.vue?vue&type=script&lang=js&"
import style0 from "./cooperation-visa-detail-list.vue?vue&type=style&index=0&id=60a4048b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a4048b",
  null
  
)

export default component.exports